export default __webpack_public_path__ + "static/media/homepage-sertification.7955dc3a.png";